import type { ReactElement } from 'react';

import BpkPopover from '@skyscanner/backpack-web/bpk-component-popover';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import StatementContent from '../StatementContent';

import type { I18nService } from '@shared/types/i18n';

import STYLES from '../RatingStatement.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  isOpen: boolean;
  onClose: () => void;
  target: ReactElement;
  i18n: I18nService;
};

const StatementPopover = ({ i18n, isOpen, onClose, target }: Props) => (
  <BpkPopover
    id="rating-statement-popover"
    label={i18n.translate('rating_explaination_title')}
    isOpen={isOpen}
    onClose={onClose}
    target={target}
    className={cls('RatingStatement__popover')}
    placement="top"
    labelAsTitle
    closeButtonIcon
    closeButtonText={i18n.translate('rating_explaination_close')}
  >
    <div className={cls('RatingStatement__popoverContent')}>
      <StatementContent />
    </div>
  </BpkPopover>
);

export default withI18n(StatementPopover);
